export enum OrganisationTab {
  LoanOfficers = "loan-officers",
  Details = "details",
  Brands = "brands",
  Activity = "activity"
}
